module.exports = __webpack_public_path__ + "img/cii-widget-tableview.815f59db.png";